<template>
    <div>
        <a v-for="(item,index) of this.allCategoryIds" :key="index" :href="$common.addDomainUrl('/productList?id='+item)"></a>
        <a v-for="(item,index) of this.allCategoryIds" :key="item+index" :href="$common.addDomainUrl('/Nouveautes/'+item)"></a>
        <a v-for="(item,index) of this.clientUrls" :key="item+index" :href="$common.addDomainUrl(item)"></a>
    </div>
</template>

<script>
// import hoverCategor from `@/assets/source/categories`
import {Message} from "element-ui";

let commonUtils = require('../utils/common_utils');
import Login from "@/views/Login";
import FillBgBox from "@/components/fillBgBox";

//用于seo获取href跳转的爬虫
export default {
    name: "topMenuHref",
    props: {
        flag: Boolean,
        loginFlag: Boolean,
        langKey: Number,
    },
    components: {FillBgBox, Login},
    computed: {
        lang() {
            return localStorage.getItem('lang')
        },
        isLogin() {
            return this.$store.state.userInfo.type != 'admin' && this.$store.state.token ? true : false
        },
        langPage() {
            return this.$store.state.langPage
        }
    },
    data() {
        return {
            isMobile: this.$store.state.isMobile,
            hoverFlag: false,
            menu: this.$store.state.menu,
            category: '',
            categoryId: this.$store.state.fast_categoryId,
            allCategoryIds: [11, 12, 13, 14, 15, 16, 1111, 1606, 110207, 110621, 110706, 110707, 110708, 110709, 111101, 111102, 111103, 111104, 111105, 111106, 111107, 111108, 111109, 111110, 120401, 120402, 120403, 120802, 120803, 130308, 130309, 130310, 130311, 130406, 130407, 130408, 130611, 130612, 140113, 140114, 140115, 140116, 140208, 160317, 160318, 160319, 160320, 160410, 160411, 160412, 160511, 160512, 160513, 160514, 160515, 160516, 160601],
            clientUrls: [
                '/homepage',
                '/downloadApp',
                '/login',
                '/sign/choose',
                '/sign/signpage/buyer',
                '/sign/signpage/seller',
                '/sign/signsuc',
                '/about',
                '/favoris',
                '/favoris/articles',
                '/favoris/vendeurs',
                '/favoris/hstorique',
                '/moncompte/informations',
                '/moncompte/entreprise',
                '/moncompte/adresses',
                '/moncompte/transporteurs',
                '/moncompte/moyens',
                '/moncompte/crticles',
                '/moncompte/commandes',
                '/commandes',
                '/result',
                '/register-success',
                '/panier',
                '/vendeur',
                '/productDetail',
                '/Help',
                '/MarquesList',
                '/404',
                '/conditions/commonPage',
                '/conditions/contact',
                '/resetPassword',
                '/sellWellProductList',
                '/tendances',
                '/promotions',
                '/campagne',
            ],
            type: '',
            lang_text: 'FR',
            hoverCategor: {},
            VetementsList: [],
            AccessoiresList: [],
            imgs: {
                bg1: require("../assets/img/bg1.svg"),
                bg2: require("../assets/img/bg2.svg"),
            },
            client_imgs: this.$store.state.client_page_imgs.topMenu,
            search_categories: [
                {
                    value: this.$store.state.langPage['v4-topmenu']['TXT_toutp'],
                    label: this.$store.state.langPage['v4-topmenu']['TXT_tout']
                },
                {
                    value: this.$store.state.langPage['v4-topmenu']['TXT_nouveautesp'],
                    label: this.$store.state.langPage['v4-topmenu']['TXT_nouveautes']
                },
                {
                    value: this.$store.state.langPage['v4-topmenu']['TXT_vetementsp'],
                    label: this.$store.state.langPage['v4-topmenu']['TXT_vetements']
                },
                {
                    value: this.$store.state.langPage['v4-topmenu']['TXT_accessoires'],
                    label: this.$store.state.langPage['menu-header']['TXT_menuaccessoires']
                },
                {
                    value: this.$store.state.langPage['v4-home-not-connected']['TXT_marques'],
                    label: this.$store.state.langPage['catalogue-filtresrecherche']['TXT_vendeur']
                },
                {
                    value: this.$store.state.langPage['v4-topmenu']['TXT_decouvrirp'],
                    label: this.$store.state.langPage['v4-topmenu']['TXT_decouvrir']
                },
                {
                    value: this.$store.state.langPage['v4-topmenu']['TXT_outletp'],
                    label: this.$store.state.langPage['menu-header']['TXT_promotions']
                },
            ],
            search_category: '',
            keywords: '',
            searchData: {},
            searchData_produits: [],
            searchData_marques: [],
            notifyDataCount: {
                fav_products_count: 0,
                car_order_count: 0,
                useful_order_count: 0,
            },
            isHome: true,
            mMenuFlag: 0, //0什么都不显示 1登录后的菜单 2搜索的页面 3未登录的主页的菜单
            isHalfClass: false,
            isShowLoginDialog: false,
            tendances: [],
            searchIdsProd: [],//搜索的产品id
            searchIdsVendeurs: [],//搜索的产品id
            personRouterlist: [
                {
                    name: [this.$store.state['langPage']['mobile-compte']['TXT_title_1']],
                    path: "/Moncompte/Informations"
                },
                {
                    name: [this.$store.state['langPage']['v4-entreprise']['TXT_monentreprise']],
                    path: "/Moncompte/Entreprise"
                },
                {
                    name: [this.$store.state['langPage']['v4-lastthing']['TXT_mesadresses']],
                    path: "/Moncompte/Adresses"
                },
                {
                    name: [this.$store.state['langPage']['compte-menu']['TXT_mestransporteurs']],
                    path: "/Moncompte/Transporteurs"
                },
                // {
                //   name: "Mes moyens de paiement",
                //   path: "/Moncompte/Moyens"
                // },
                {
                    name: [this.$store.state['langPage']['compte-menu']['TXT_mescommandes'], this.$store.state['langPage']['v4-lastthing']['TXT_monarticles']],
                    path: "/Commandes"
                },
                {
                    name: [this.$store.state['langPage']['catalogue-filtres']['TXT_promotions']],
                    path: "/promotions"
                },
                {
                    name: [this.$t("account.word1")],
                    path: "/"
                }
            ],
            mobile_menu_item_type_name: null,//要显示的移动端二级菜单 null的时候显示一级菜单，其他名字的时候显示对应名字的二级菜单
        }
    },
    async created() {
        let langs = localStorage.getItem('lang') || 'fr'
        if (langs) this.lang_text = langs.toLocaleUpperCase()
        this.hoverCategor = require(`../assets/source/categories.${langs.toLocaleLowerCase()}.json`)
        this.setAppClass();
        await this.getAllCategoryIds();
        // this.filterVeteme()
        // this.filterAccess()
        // console.log(this.hoverCategor)
    },
    mounted() {
        if (this._isMobile()) {
            // this.$router.replace('/downloadApp');
            this.getTendances();
        }
        // this.$api.menu.getMenuProduits(11).then(data => {
        //     console.log('Produits', data)
        // })
        // this.$api.menu.getMenuVendeurs(11).then(data => {
        //     console.log('Vendeurs', data)
        // })
        this.isHome = this.$route.path === '/';
        console.log('缓存菜单', this.$store.state.menu)
        this.menu = this.$store.state.menu;//先使用缓存的菜单，等获取到新菜单再用新的
        this.$api.menu.getTopmenu({id_langue: this.lang}).then(data => {
            console.log(data)
            this.$store.commit('set', {key: 'menu', value: data.result.data})
            this.menu = this.$store.state.menu;
            let menuKeys = Object.keys(this.menu);
            for (let key of menuKeys) {
                let valueMenu = this.menu[key];
                if (valueMenu.id_categorie == this.$store.state.fast_categoryId) {
                    this.category = key;
                }
            }
        });
        if (this.isLogin) {
            this.$api.info.getInfo().then(res => {
                if (res.acheteur) {
                    this.$store.commit('set', {key: 'userInfo', value: res.acheteur});
                }
            })
            this.$api.info.getV2Info().then(res => {
                if (res.code === 0) {
                    this.notifyDataCount = res.data.notifyDataCount;
                }
            })
        }
        this.replaceClientImgs();
    },
    methods: {
        categorys(cateKey, para) {
            this.category = cateKey
            this.categoryId = parseInt(para.id_categorie)
            // localStorage.setItem('fast_category_id', this.categoryId)
            this.$store.commit('set', {key: 'fast_categoryId', value: this.categoryId})
            this.$store.commit('set', {key: 'fast_category_name', value: this.category})
        },
        langChang(command) {
            this.lang_text = command.toLocaleUpperCase()
            localStorage.setItem('lang', command)
            let langJson = require(`../assets/source/langV4/langv4.${this.lang_text.toLocaleLowerCase()}.json`)
            this.$store.commit('set', {key: 'langPage', value: langJson})
            this.$store.commit('set', {key: 'lang', value: command})
            // this.$api.menu.getLang({id_langue:command}).then(data=>{
            //     this.$store.commit('set',{key:'langPage',value:data})
            // })
            this.$i18n.locale = command
            window.location.reload()
            // this.langKey++
        },
        goBlock(el) {
            this.$common.EventBus.$emit('goBlock', el)
        },
        miceOver(key) {
            this.hoverFlag = true
            this.type = key
        },
        miceLeave() {
            this.hoverFlag = false
        },
        toFavoris() {
            this.$router.push({name: 'favoris'})
        },
        toMoncompte() {
            this.$router.push({name: 'Moncompte'})
        },
        toPanier() {
            this.$router.push({name: 'Panier'})
        },
        //顶部菜单的产品列表下拉的子项被点击了
        onMenuChildClick(modelTypeId, categoriesId, type = 'productList', obj) {
            //type 'newModel'新品模块, 'productList'产品列表,'seller'是商家图标。不同的跳完不同的链接
            console.log(modelTypeId)
            if (type === 'newModel') {
                if (obj.parentTypeKey === 'NOUVEAUX VENDEURS') {
                    this.onMenuChildClick(null, modelTypeId, 'seller')
                } else this.onClickNewSeeMore(obj.parentTypeKey, modelTypeId)
            } else if (type === 'productList') {
                this.$router.push(`/productList?id=${categoriesId}`)
            } else if (type === 'seller') {
                let newPage = this.$router.resolve({path: `/vendeur/${categoriesId}`})//这里的categoriesId是商家id
                window.open(newPage.href, '_blank')
            }
            console.log(modelTypeId, categoriesId);
        },
        onTopLogoClick() {
            this.$router.replace('/homepage');
        },
        //菜单栏里面Nouveautés的右边图片被点击
        onMenuPushImgClick(item) {
            let vid = commonUtils.getCenterStr(item.img_url, 'Boutiques/', '/Produits');
            this.$router.push({path: '/ProductDetail', query: {id: item.id_produit, vid: vid}})
        },
        //点击搜索产品
        kwSearch(queryString, cb) {
            let query = {
                id_langue: this.$store.state["lang"] ? this.$store.state["lang"] : "fr",
                keywords: this.keywords,
            };
            if (this.search_category) {
                query.type = this.search_category;
            }
            this.$api.good.search(query).then(res => {
                if (res.code === 0) {
                    this.searchData = res.data;
                    this.searchData_produits = this.searchData.produits;
                    this.searchData_marques = this.searchData.marques;
                    this.searchIdsProd = [];
                    this.searchIdsVendeurs = [];

                    this.searchData_produits.forEach(prod => {
                        prod.value = prod.reference;
                        prod.search_type = 'produit';
                        this.searchIdsProd.push(prod.id_produit);
                    })
                    this.searchData_marques.forEach(marque => {
                        marque.value = marque.nom_marque;
                        marque.search_type = 'marque';
                        this.searchIdsVendeurs.push(marque.id_vendeur);
                    })
                    let results = [
                        {title: 'produit', list: this.searchData_produits,},
                        {title: 'marques', list: this.searchData_marques,},
                    ]
                    cb(results);
                }
            });
            if (this.keywords) {
                let body = {
                    libelle: this.keywords,
                    link: 'http://www.baidu.com',
                    id_langue: this.$store.state.lang
                };
                this.$api.good.addTrackSearch(body).then(res => {
                });
            }
        },
        //用户点击了他所搜索的产品
        handleSelect(item) {
            console.log('handleSelect', item);
            if (item.search_type === 'produit') {
                this.$router.push(`/ProductDetail?id=${item.id_produit}&vendu_par=${item.vendu_par}&vid=${item.id_vendeur}&categorie_id=${item.id_categorie}`);
            } else if (item.search_type === 'marque') {
                this.$router.push(`/vendeur/${item.id_vendeur}`);
            }
        },
        onClickOutletRemise(item) {
            let type = item.type;
            let url = `/ProductList`;
            if (type) url += `/${type}`;
            let params = '';
            if (item.promotion_debut || item.promotion_debut === 0) params += `&promotion_debut=${item.promotion_debut}`;
            if (item.promotion_fin) params += `&promotion_fin=${item.promotion_fin}`;
            if (item.prix_debut || item.prix_debut === 0) params += `&prix_debut=${item.prix_debut}`;
            if (item.prix_fin) params += `&prix_fin=${item.prix_fin}`;
            if (params) params = '?' + params.substring(1);
            window.location.href = window.origin + `${url}${params}`;
        },
        _isMobile() {
            let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
            this.$store.commit('set', {key: 'isMobile', value: flag});
            return flag;
        },
        //当点击了移动端的菜单的按钮
        onClickMenuOrCloseBtn() {
            if (this.mMenuFlag !== 0) {
                return this.mMenuFlag = 0;
            } else if (this.isLogin) {
                return this.mMenuFlag = 1;
            } else if (!this.isLogin && this.isHome) {
                return this.mMenuFlag = 3;
            }
            return this.mMenuFlag = 1;
        },
        //获取菜单的一些单词翻译
        getTopMenuDesc(typeKey) {
            try {
                let keys = Object.keys(this.$t(`topMenuDesc`));
                if (typeKey === "AJOURD'HUI") {
                    typeKey = "AJOURD HUI";
                }
                if (!keys.includes(typeKey)) return typeKey;
                return this.$t(`topMenuDesc.${typeKey}`);
            } catch (e) {
                return '' + e;
            }
        },
        //顶部分类菜单的按钮点击
        categoryMenuClick(typeKey) {
            switch (typeKey) {
                case 'Accessoires':
                    window.location.href = window.origin + `/productList?id=16`;
                    break;
                case 'Marques':
                    window.location.href = window.origin + '/marquesList';
                    break;
                case 'Nouveautés':
                    window.location.href = window.origin + `/Nouveautes/${this.menu[this.category]['id_categorie']}`;
                    break;
                case 'Outlet':
                    this.onClickOutletRemise({
                        type: this.menu[this.category]['id_categorie'],
                        promotion_debut: 0,
                        promotion_fin: 100
                    })
                    break;
                case 'Vêtements':
                    window.location.href = window.origin + `/productList?id=${this.menu[this.category]['id_categorie']}`;
                    break;
                case 'Tendances':
                    this.$router.push(`/tendances`);
                    break;
            }
        },
        //转化菜单的keyNa
        convertMenuKeyName() {

        },
        // 设置不同的appContainer的class
        setAppClass() {
            // this.isHalfClass = ['/','/homepage','/about' ].includes(this.$route.path) && !this.isMobile;
            this.isHalfClass = !this.isMobile;
        },
        //点击了查看新品更多的按钮
        onClickNewSeeMore(itemKey, category = '11') {
            console.log(itemKey, category);
            let date_creation_debut = null;
            switch (itemKey) {
                case `AJOURD'HUI`:
                    date_creation_debut = (new Date(Date.now() - (24 * 60 * 60 * 1000))).format('yyyy-MM-dd');
                    this.$router.push(`/Nouveautes/${category}?date_creation_debut=${date_creation_debut}`);
                    break;
                case `CETTE SEMAINE`:
                    date_creation_debut = (new Date(Date.now() - (24 * 60 * 60 * 1000 * 7))).format('yyyy-MM-dd');
                    this.$router.push(`/Nouveautes/${category}?date_creation_debut=${date_creation_debut}`);
                    break;
                case `NOUVEAUX VENDEURS`:
                    this.$router.push('/marquesList');
                    break;
            }
        },
        async getTendances() {
            if (!this.isLogin) return;
            let res = await this.$api.good.get_tendances();
            if (res.code != 0) return;
            this.tendances = res.data;
        },
        //查看所有的产品
        showAll() {
            if (commonUtils.isEmpty(this.searchIdsVendeurs)
                && commonUtils.isEmpty(this.searchIdsProd)) Message.error('search is empty');
            window.location.href = `/productList?vendeurs=${this.searchIdsVendeurs}&produits=${this.searchIdsProd}&searchWord=${this.keywords}`;
        },
        async onPersonMenuItemClick(item) {
            if (item.name[0] === this.$t("account.word1")) {
                this.logout();
            } else {
                this.$router.push(item.path);
            }
        },
        async logout() {
            localStorage.clear();
            this.$store.commit('set', {key: 'token', value: ''});
            window.document.cookie = '';
            commonUtils.delCookie('acheteurlogin');
            this.$router.replace({path: '/'})
        },
        //点击了减免便宜价格的图片
        async onClickDiscountImg() {
            this.$router.push('/productList?prix_fin=5');
        },
        //替换客户端图片
        replaceClientImgs() {
            console.log('client_imgs', this.client_imgs,)
            let clientImgs = this.client_imgs;
            if (Object.keys(clientImgs).length == 0) return;
            for (let key of Object.keys(this.imgs)) {
                this.imgs[key] = clientImgs[key].file_url;
            }
            console.log('client_imgs2', this.imgs)
            this.$forceUpdate();
        },
        //点击移动端的
        onClickMobileMenuSubTitle(typeKey) {
            if (typeKey == 'Marques') {
                this.$router.push('/MarquesList');
            } else {
                this.mobile_menu_item_type_name = typeKey;
            }
        },
        onClickLogin() {
            // this.isShowLoginDialog = true;
            this.$router.push('/login');
        },
    },
}
</script>

<style scoped lang="less">
.topMenu {
    position: relative;
    overflow: visible;

    &.in {
        min-height: .6rem;
        position: absolute;
        top: 0;
        z-index: 1;
        width: 100%;
    }

    &.out {
        min-height: .6rem;
        position: relative;
    }

    &.halfWidth {
        @media only screen and (min-width: 1440px) {
            width: 1440px;
        }
    }

    box-sizing: content-box;

    .menu {
        padding: 10px 64px 20px;
        min-height: .4rem;
        position: relative;
        width: 100%;

        &.black {
            color: #000;

            a {
                color: #000;
            }

            .lang {
                color: #000;

                .el-dropdown-link {
                    i {
                        color: #000;
                    }
                }

            }
        }

        &.white {
            color: #FFFFFF;

            a {
                color: #FFFFFF;
            }

            .lang {
                color: #FFFFFF;

                .el-dropdown-link {
                    i {
                        color: #FFFFFF;
                    }
                }
            }
        }

        .navList {
            display: inline-block;
            width: 50%;
            height: .33rem;
            line-height: .33rem;
            vertical-align: top;

            .nav {
                font-family: MaisonNeue-Medium;
                display: inline-block;
                margin-right: 30px;
                font-size: 14px;
                /*line-height: .16rem;*/
                /*height: .16rem;*/
                cursor: pointer;
                position: relative;
                overflow: visible;

                &.child {
                    font-family: MaisonNeue-Light;
                }

                &.act {
                    text-decoration-line: underline;
                }

                .icon {
                    width: 22.5px;
                    vertical-align: middle;
                }

                .num {
                    position: absolute;
                    top: 0;
                    right: -.1rem;
                    font-size: 0.05rem;
                    height: 1.1vw;
                    width: 1.1vw;
                    text-align: center;
                    line-height: .17rem;
                    border-radius: 2rem;
                    font-family: MaisonNeue-Medium;
                    color: #fff;
                    background-color: #000;
                }

                .childs {
                    font-family: "MaisonNeue-Light";
                    display: inline-block;
                    font-size: 14px;
                    /*line-height: .16rem;*/
                    /*height: .16rem;*/
                    cursor: pointer;
                    position: relative;
                    overflow: visible;

                }

                .childs:hover {
                    text-decoration-line: underline;
                }
            }

            .lang {
                vertical-align: top;
            }

            .search {
                display: inline-block;
                width: 280px;
                float: right;
                height: .4rem;

                .el-input__icon {
                    font-size: 0.16rem;
                    line-height: 20px;
                }
            }

        }

        .navListHome {
            display: inline-block;
            width: 47%;
            margin-right: 3%;
            height: .33rem;
            line-height: .33rem;
            vertical-align: top;

            .nav {
                font-family: MaisonNeue-Medium;
                display: inline-block;
                margin-right: 15px;
                font-size: 14px;
                /*line-height: .16rem;*/
                /*height: .16rem;*/
                cursor: pointer;
                position: relative;
                overflow: visible;
            }
        }

        .logo {
            position: absolute;
            width: 117px;
            left: 50%;
            margin-left: -.55rem;
            margin-top: 0.045rem;
        }

        .searchContainer {
            position: absolute;
            right: 0;
            vertical-align: baseline;

            .el-select {
                border: none !important;
            }

            .el-select /deep/ .el-input {
                border: none !important;
                border-color: #fff;
            }

            .el-select /deep/ input {
                border: none !important;
                font-size: 14px;
            }

            .el-select /deep/ input::placeholder {
                color: black;
            }

            .selectBox {
                width: 10vw;
                padding-right: 0;
                margin-right: 0;

                .placeHolder {
                    margin-left: 20px;
                    font-size: 122pt;
                }
            }
        }
    }

    .topOutlet {
        display: flex;
        flex-wrap: wrap;
        position: relative;
        width: 100%;
        height: 20vw;

        .leftContainer {
        }

        .rightContainer {
            margin-left: 5vw;
        }

        .bg1 {
            height: 20vw;
            width: 15vw;
            background-size: cover;
            text-align: center;
            cursor: pointer;

            div {
                padding-top: 50%
            }

            p {
                font-size: 0.13rem
            }

            span {
                font-size: 0.4rem
            }
        }

        .bg2 {
            height: 20vw;
            width: 15vw;
            background-size: cover;
            text-align: center;
            cursor: pointer;

            div {
                padding-top: 50%
            }

            p {
                font-size: 0.13rem
            }

            span {
                font-size: 0.4rem
            }
        }
    }

    .listMenu {
        position: absolute;
        padding: 10px .5rem 0.27rem;
        margin-top: 15px;
        background-color: #F6F3F1;
        top: .8rem;
        width: 100%;
        z-index: 10;
        min-height: 1rem;

        .menuCont {
            display: flex;
            justify-content: space-between;

            .menuItem {
                &_li {
                    // margin-right: 64px;
                    .noPush {
                        p {
                            font-family: MaisonNeue-Bold;
                            margin-bottom: 14px;
                            font-size: 14px;
                        }

                        > div {
                            font-family: MaisonNeue-Light;
                            margin-bottom: 14px;
                            font-size: 14px;
                        }

                        > div:hover {
                            text-decoration: underline;
                        }

                        .imgs {
                            width: 192px;
                            height: 111px;
                            display: inline-block;
                            margin: 0 16px;

                            img {
                                width: 192px;
                                height: 111px;
                                display: block;
                            }

                            .img2 {
                                width: 192px;
                                height: 111px;
                                display: block;
                            }
                        }
                    }

                    .tout {
                        cursor: pointer;
                    }

                    .Marque {
                        min-width: 800px;
                        width: 900px;

                        .autres {
                            margin-left: 144px;
                        }

                        .autres-right {
                            margin-left: 144px;
                        }

                        .tout {
                            margin-left: 144px;
                            cursor: pointer;
                        }
                    }

                    .isPush {
                        display: flex;
                        justify-content: right;

                        > div {
                            margin-left: 32px;

                            p {
                                font-family: MaisonNeue-Bold;
                                font-size: 14px;
                                margin-top: 0.06rem;
                            }

                            img {
                                // width: 304px;
                                // height: 380px;
                                display: block;
                            }

                            .nouv-img {
                                width: 304px;
                                height: 380px;
                            }
                        }
                    }
                }
            }

            .vetem {
                p {
                    font-family: MaisonNeue-Bold;
                    margin-bottom: 14px;
                    font-size: 14px;
                }

                p:hover {
                    text-decoration: underline;
                }

                > div {
                    cursor: pointer;
                    font-family: MaisonNeue-Light;
                    margin-bottom: 14px;
                    font-size: 14px;
                }

                div:hover {
                    text-decoration: underline;
                }

                .imgs {
                    width: 192px;
                    height: 111px;
                    display: inline-block;
                    margin: 0 16px;

                    img {
                        width: 192px;
                        height: 111px;
                        display: block;
                    }
                }
            }

            .vetem-push {
                p {
                    font-family: MaisonNeue-Bold;
                    font-size: 14px;
                    margin-top: 0.06rem;
                }
            }
        }
    }

    .shadow {
        //width: 100%;
        height: 1px;
        box-shadow: 0px 3px 3px rgba(0, 0, 0, 0.1);
        margin-bottom: 10px;
        margin-top: 16px;
        //position: absolute;
        //display: flex;
        //flex-grow: 1;
        //left: 0;
        width: calc(100% + 128px);
        margin-left: -64px;
    }

    /deep/ .el-dialog {
        width: 0%;
        height: 80%;
    }
}

.mTopMenu {
    .content {
        display: flex;
        position: relative;
        height: 13vw;
        padding: 0 24px;

        .leftMenu {
            width: 4.8vw;
            height: 4.8vw;
        }

        .centerLogoIcon {
            position: absolute;
            width: 25vw;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
        }

        .rightMenu {
            display: flex;

            .rightSearch {
                font-size: 10pt;
                width: 4.8vw;
                height: 4.8vw;
                margin-right: 5vw;
            }

            .rightShopCar {
                width: 4.8vw;
                height: 4.8vw;
            }

            .icon {
                width: 4.8vw;
                height: 4.8vw;
            }

            .lang {
                margin-left: 2vw;
                color: #000;

                .el-dropdown-link {
                    i {
                        color: #000;
                    }
                }

            }
        }
    }

    .menuDetailContainer {
        width: 100vw;
        min-height: 100vh;
        display: inline-block;
        position: absolute;
        z-index: 10;
        background-color: #F6F3F1;
        padding: 6.4vw 24px;

        .collapseTopMenu {
            height: 20px;
            display: flex;
            align-items: center;

            .title {

            }

            .itembtn {
                padding: 5px 0;
            }
        }

        .collapseMenu {
            .itembtn {
                padding: 5px 0;
            }
        }

        .subMenuBox {
            margin: 10px 0;
        }

        .navList {
            display: flex;
            width: 100%;
            margin-bottom: 7vw;

            .nav {
                margin-right: 10vw;
                font-family: "MaisonNeue-Light";
                display: inline-block;
                font-size: 10pt;
                cursor: pointer;
                position: relative;
                overflow: visible;

                &.child {
                    font-family: MaisonNeue-Light;
                }

                &.act {
                    text-decoration-line: underline;
                }
            }
        }

        .menuItem {
            &_li {
                // margin-right: 64px;
                .noPush {
                    p {
                        font-family: MaisonNeue-Bold;
                        margin-bottom: 14px;
                        font-size: 8pt;
                    }

                    > div {
                        font-family: MaisonNeue-Light;
                        margin-bottom: 18px;
                        font-size: 8pt;
                    }

                    .imgsBox {
                        display: flex;
                        flex-wrap: wrap;
                        width: 100vw;

                        .imgs {
                            //display: inline-block;
                            margin: 5px 8px;

                            img {
                                width: 40vw;
                                height: 20vw;
                                display: block;
                            }
                        }
                    }

                }

                .Marque {
                    min-width: 800px;
                    width: 900px;

                    .autres {
                        margin-left: 3vw;
                    }

                    .autres-right {
                    }

                    .tout {
                        margin-left: 144px;
                        cursor: pointer;
                    }
                }

                .isPush {
                    display: flex;
                    justify-content: right;

                    > div {
                        margin-left: 32px;

                        p {
                            font-family: MaisonNeue-Bold;
                            font-size: 8pt;
                            margin-top: 1vw;
                        }

                        img {
                            // width: 304px;
                            // height: 380px;
                            display: block;
                        }

                        .nouv-img {
                            width: 304px;
                            height: 380px;
                        }
                    }
                }
            }
        }

        .vetem {
            p {
                font-family: MaisonNeue-Bold;
                margin-bottom: 14px;
                font-size: 8pt;
            }

            > div {
                cursor: pointer;
                font-family: MaisonNeue-Light;
                margin-bottom: 14px;
                font-size: 8pt;
            }

            .imgs {
                width: 192px;
                height: 111px;
                display: inline-block;
                margin: 0 16px;

                img {
                    width: 192px;
                    height: 111px;
                    display: block;
                }
            }
        }

        .vetem-push {
            p {
                font-family: MaisonNeue-Bold;
                font-size: 8pt;
                margin-top: 1vw;
            }
        }

        .topOutlet {

            .bg1 {
                height: 90vw;
                width: 60vw;
                background-size: cover;
                text-align: center;
                cursor: pointer;

                div {
                    padding-top: 50%
                }

                p {
                    font-size: 14pt
                }

                span {
                    font-size: 80pt
                }
            }

            .bg2 {
                height: 90vw;
                width: 60vw;
                background-size: cover;
                text-align: center;
                cursor: pointer;

                div {
                    padding-top: 50%
                }

                p {
                    font-size: 14pt
                }

                span {
                    font-size: 80pt
                }
            }
        }

        .personMenu {
            width: 100%;
            margin-top: 3vw;

            .nav {
                margin-right: 10vw;
                margin-top: 8vw;
                font-family: "MaisonNeue-Light";
                font-size: 10pt;
                cursor: pointer;
                position: relative;

                .icon {
                    width: 5vw;
                }

                .num {
                    position: absolute;
                    top: -1.3vw;
                    left: 3vw;
                    padding-top: 2px;
                    font-size: 8pt;
                    height: 4.2vw;
                    width: 4.2vw;
                    text-align: center;
                    color: #fff;
                    background-color: #000;
                    border-radius: 100vw;
                }

                .name {
                    margin-left: 5vw;
                    font-size: 10pt;
                    font-weight: bold;
                }

                .childs {
                    font-family: "MaisonNeue-Light";
                    display: inline-block;
                    font-size: 12pt;
                    cursor: pointer;
                    position: relative;
                    overflow: visible;
                }
            }
        }

        .search {
            /*display: inline-block;*/
            /*width: 20vw;*/
            /*float: right;*/
            /*height: .4rem;*/

            /*.el-input__icon {*/
            /*    font-size: 0.16rem;*/
            /*    line-height: 20px;*/
            /*}*/
        }
    }

    .mSearchContainer {
        width: 100vw;
        min-height: 100vh;
        display: inline-block;
        position: absolute;
        z-index: 10;
        background-color: white;

        .search {
            width: 100%;
        }
    }

    .menuHomeContainer {
        display: inline-block;
        position: absolute;
        z-index: 10;
        background-color: white;
        padding: 3vw 3vw 0 3vw;

        .navList {
            width: 100%;

            .nav {
                margin-right: 10vw;
                font-family: "MaisonNeue-Light";
                font-size: 10pt;
                cursor: pointer;
                font-weight: bold;
                margin-bottom: 3vw;

                &.child {
                    font-family: MaisonNeue-Light;
                }

                &.act {
                    text-decoration-line: underline;
                }
            }
        }
    }
}
</style>
